import React from 'react';
interface IconProps {
    width?: number;
    height?: number;
}

const ArrowLongDownIcon = (props: IconProps) => {
    return (
        <svg viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.003 1a.451.451 0 00-.325.119.402.402 0 00-.124.304v8.899l.047 1.749.261-.096-2.079-2.14-2.025-1.916a.389.389 0 00-.144-.086.543.543 0 00-.178-.029c-.125 0-.23.04-.312.119A.402.402 0 001 8.227c0 .115.047.22.14.314l4.521 4.318a.479.479 0 00.52.106.52.52 0 00.158-.106l4.527-4.318A.445.445 0 0011 8.227a.402.402 0 00-.124-.304.433.433 0 00-.312-.119.543.543 0 00-.178.029.39.39 0 00-.144.086L8.21 9.835l-2.08 2.14.27.096.053-1.75V1.424a.397.397 0 00-.128-.304A.454.454 0 006.003 1z"
                fill="currentColor"
                stroke="currentColor"
            />
        </svg>
    );
};

export default ArrowLongDownIcon;
